"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiBanner = /** @class */ (function (_super) {
    __extends(ApiBanner, _super);
    function ApiBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_BANNER_NEW_ID = '/api/banner/getNewId';
        _this.GET_BANNER_LIST = '/api/banner/v2/listsByPosition';
        _this.GET_BANNER_LIST_ALL = '/api/banner/listsByPosition';
        _this.GET_EVENT_BANNER_LIST = '/api/banner/event/lists';
        _this.GET_BANNER = '/api/banner';
        _this.UPDATE_BANNER = '/api/banner/update';
        _this.UPDATE_SORT_WEEKLY = '/api/banner/sortbyclass';
        _this.UPDATE_SORT = '/api/banner/sortByPosition';
        _this.UPDATE_BANNER_IMAGE_SORT = '/api/image/banner/sort';
        _this.DELETE_BANNER = '/api/banner/bannerStatusDeleted';
        _this.GET_GROUP_BANNER_ID = '/api/banner/group/getNewId';
        _this.GET_GROUP_BANNER_LIST = '/api/banner/group/lists';
        _this.GET_GROUP_BANNER_ITEM = '/api/banner/group/get';
        _this.UPDATE_GROUP_BANNER_ITEM = '/api/banner/group/set';
        _this.DELETE_GROUP_BANNER_ITEM = '/api/banner/group/delete';
        /**
         * banner 신규 id 발급
         * @param accesstoken
         * @param language
         * @param position
         * @returns
         */
        _this.getBannerNewId = function (accesstoken, language, position) {
            var data = {
                language: language,
                position: position,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_BANNER_NEW_ID,
                data: data,
            });
            return config;
        };
        /**
         * Position에 대한 설정된 banner 리스트
         * @param accesstoken
         * @param language
         * @param position
         * @returns
         */
        _this.getBannerList = function (accesstoken, language, position) {
            var data = {
                language: language,
                position: position,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_BANNER_LIST,
                data: data,
            });
            return config;
        };
        _this.getEventBannerList = function (accesstoken, language, position) {
            var data = {
                language: language,
                position: position,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_EVENT_BANNER_LIST,
                data: data,
            });
            return config;
        };
        /**
         * position에 대한 banner전체 리스트
         * @param accesstoken
         * @param language
         * @param position
         * @returns
         */
        _this.getBannerListAll = function (accesstoken, language, position) {
            var data = {
                language: language,
                position: position,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_BANNER_LIST_ALL,
                data: data,
            });
            return config;
        };
        /**
         * banner 상세정보
         * @param accesstoken
         * @param language
         * @param bannerId
         */
        _this.getBanner = function (accesstoken, language, bannerId) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: "".concat(_this.GET_BANNER, "/").concat(bannerId),
                data: data,
            });
            return config;
        };
        /**
         * 배너 상세정보 업데이트
         * @param accesstoken
         * @param bannerId
         * @param request
         * @returns
         */
        _this.updateBanner = function (accesstoken, bannerId, request) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: "".concat(_this.UPDATE_BANNER, "/").concat(bannerId),
                data: request,
            });
            return config;
        };
        /**
         * 요일별 배너 정렬 업데이트
         * @param accesstoken
         * @param language
         * @param position
         * @param bannerIds
         * @returns
         */
        _this.updateBannerSortWeekly = function (accesstoken, language, position, bannerIds) {
            var data = {
                language: language,
                position: position,
                bannerIds: bannerIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_SORT_WEEKLY,
                data: data,
            });
            return config;
        };
        _this.updateBannerSort = function (accesstoken, language, position, bannerIds) {
            var data = {
                language: language,
                position: position,
                bannerIds: bannerIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_SORT,
                data: data,
            });
            return config;
        };
        /**
         * banner image 정렬
         * @param accesstoken
         * @param bannerId
         * @param imageIds
         * @param device
         * @returns
         */
        _this.updateBannerImageSort = function (accesstoken, bannerId, imageIds, device) {
            var data = {
                device: device,
                bannerId: bannerId,
                imageIds: imageIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_BANNER_IMAGE_SORT,
                data: data,
            });
            return config;
        };
        /**
         * banner 삭제
         * @param accesstoken
         * @param language
         * @param bannerId
         * @returns
         */
        _this.deleteBanner = function (accesstoken, language, bannerId) {
            var data = {
                language: language,
                bannerId: bannerId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.DELETE_BANNER,
                data: data,
            });
            return config;
        };
        /**
         * 배너 그룹관련 API
         * @param accesstoken
         * @param type
         * @returns
         */
        _this.getGroupBannerId = function (accesstoken, type, language) {
            var data = {
                type: type,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken, language: language },
                method: 'post',
                url: _this.GET_GROUP_BANNER_ID,
                data: data,
            });
            return config;
        };
        _this.getGroupBannerList = function (accesstoken, type, language) {
            var data = {
                type: type,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken, language: language },
                method: 'post',
                url: _this.GET_GROUP_BANNER_LIST,
                data: data,
            });
            return config;
        };
        _this.getGroupBannerItem = function (accesstoken, type, bannerGroupId) {
            var data = {
                type: type,
                bannerGroupId: bannerGroupId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_GROUP_BANNER_ITEM,
                data: data,
            });
            return config;
        };
        _this.updateGroupBannerItem = function (accesstoken, request) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_GROUP_BANNER_ITEM,
                data: request,
            });
            return config;
        };
        _this.deleteGroupBannerList = function (accesstoken, type, bannerGroupId) {
            var data = {
                type: type,
                bannerGroupId: bannerGroupId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.DELETE_GROUP_BANNER_ITEM,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiBanner.getInstance = function (initValue) {
        if (!ApiBanner.classInstance) {
            this.classInstance = new ApiBanner(initValue);
        }
        return this.classInstance;
    };
    return ApiBanner;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiBanner;
